// TODO: Moaaz, remove the layout content height after refactoring the tables
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useBreakpointValue,
} from 'design-system';
import { HeaderContainer } from 'layout/components/header/header-container';
import { HeaderLeft } from 'layout/components/header/header-left';
import { HeaderRight } from 'layout/components/header/header-right';
import { Sidebar } from 'layout/components/sidebar/sidebar';
import { Section } from 'layout/index';
import { LayoutProps } from 'layout/types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { closeMobileSidebar } from 'redux/sidebar/reducer';

export const SidebarPageLayout = ({ sections }: LayoutProps) => {
  const isSidebarOpen = useAppSelector((state) => state.sidebar.isOpen);
  const isMobileSidebarOpen = useAppSelector((state) => state.sidebar.isMobileOpen);
  const sidebarWidth = isSidebarOpen ? 268 : 76;
  const headerHight = 68;

  const dispatch = useAppDispatch();
  const location = useLocation();
  const isMobile = useBreakpointValue({ base: true, md: false });

  // Navigating from a drawer link must dismiss the drawer, otherwise the
  // overlay keeps covering the page the user just navigated to
  useEffect(() => {
    dispatch(closeMobileSidebar());
  }, [location.pathname]);

  return (
    <Flex as='main' minH={'100vh'} direction={'row'}>
      {/* Start Sider (static rail, md and up) */}
      <Box
        as='aside'
        display={{ base: 'none', md: 'block' }}
        w={`${sidebarWidth}px`}
        minW={`${sidebarWidth}px`}
        transition='width 0.25s ease, min-width 0.25s ease'
        borderEnd={'2px solid'}
        borderColor={'#e6e7ef'}
        h={'100vh'}
        overflowY={'auto'}
        overflowX={'hidden'}>
        <Section sections={sections} name='sider'>
          <Sidebar />
        </Section>
      </Box>
      {/* End Sider */}

      {/* Start Sider (overlay drawer, below md). Mounted only on mobile — an
          open drawer scroll-locks the body even when visually hidden, so a
          display-based toggle would freeze the page after resizing up */}
      {isMobile && (
        <Drawer
          isOpen={isMobileSidebarOpen}
          onClose={() => dispatch(closeMobileSidebar())}
          placement='start'
          autoFocus={false}>
          <DrawerOverlay />
          <DrawerContent maxW='300px'>
            <DrawerCloseButton zIndex='popover' />
            <DrawerBody p={0}>
              <Sidebar variant='drawer' />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}
      {/* End Sider */}

      <Flex as='main' minH={'100vh'} direction={'column'} flexGrow={1} minW={0}>
        <Box as='header'>
          {/* Start Header */}
          <Section sections={sections} name='header'>
            <HeaderContainer>
              <HeaderLeft />
              <HeaderRight />
            </HeaderContainer>
          </Section>
          {/* End Header */}
        </Box>

        {/* Start Content */}
        <Box
          as='section'
          bgColor='gray.50'
          p={{ base: 'sm', md: 'md' }}
          h={`calc(100vh - ${headerHight}px)`}
          w={{ base: '100vw', md: `calc(100vw - ${sidebarWidth}px)` }}
          transition='width 0.25s ease'
          overflowY={'auto'}
          sx={{
            // Mobile browsers overlay their own chrome on 100vh; dvh tracks
            // the actually-visible viewport so the content bottom stays reachable
            '@supports (height: 100dvh)': {
              height: `calc(100dvh - ${headerHight}px)`,
            },
          }}>
          <Section sections={sections} name='content' />
        </Box>
        {/* End Content */}
      </Flex>
    </Flex>
  );
};
